import React, { createContext, useRef, useState, useEffect, useContext } from 'react';
import useSubscriptions from '../components/Conversations/Conversation/useSubscriptions';
import AuthContext from './AuthContext';
import { CONVERSATION_PENDING } from '../components/Conversations/Conversation/queries';
import { CONVERSATIONS } from '../components/Conversations/queries';
import { useQuery, useSubscription } from '@apollo/client';

const MessageInputContext = createContext();

export const MessageInputProvider = ({ children }) => {

  const { apolloClient:client } = useContext(AuthContext);

  const currentMessageInputRef = useRef();
  const [currentConversationId, setCurrentConversationId] = useState();
  const [currentConversationIds, setCurrentConversationIds] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [pendingResponseIds, setPendingResponseIds] = useState([]);
  const [openIds, setOpenIds] = useState([]);
  const [collapsedIds, setCollapsedIds] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [body, setBody] = useState('');

  useEffect(() => {
    if(conversations) {
      const newConversations = conversations.filter(convo => convo.isPendingResponse);
      setPendingResponseIds(newConversations.map(convo => convo.id));
    }
  }, [conversations])

  useSubscription(CONVERSATION_PENDING, {
    variables: {},
    client: client,
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!data || !data.conversationPending) return;

      const updatedConversation = data.conversationPending.conversation;
      const currentData = client.readQuery({
        query: CONVERSATIONS, variables: { scopes: ['pending'] }
      });

      if (!currentData) { return; }
      const { conversations } = currentData;

      let updatedConversations = [
        ...conversations.filter(conversation => (
          updatedConversation.id !== conversation.id ||
          (updatedConversation.id === conversation.id && conversation.isPendingResponse)
        ))
      ];

      setConversations(updatedConversations);
      setPendingResponseIds(updatedConversations.map((convo) => convo.id));

      if (!updatedConversation.destroyed) {
        updatedConversations = [...updatedConversations, updatedConversation];
      };

      client.writeQuery({
        query: CONVERSATIONS,
        variables: { scopes: ['pending'] },
        data: { conversations: updatedConversations },
      });
    }
  });

  useEffect(() => {
    setBody('');
  }, [currentConversationIds])

  const addToOpens = (id) => {
    if(!openIds.includes(id)) {
      setOpenIds([...openIds, id]);
    }
  }

  const removeFromOpens = (id) => {
    if(openIds.includes(id)) {
      const newOpens = openIds.filter(openId => parseInt(openId) !== parseInt(id));
      setOpenIds(newOpens)
    }
  }

  const addToCollapsed = (id) => {
    if(!collapsedIds.includes(id)) {
      setCollapsedIds([...collapsedIds, id]);
    }
  }

  const removeFromCollapsed = (id) => {
    if(collapsedIds.includes(id)) {
      const newCollapsed = collapsedIds.filter((collapsedId) => parseInt(collapsedId) !== parseInt(id));
      setCollapsedIds(newCollapsed);
    }
  }

  const getConversationBuyerName = (id, collapsed) => {
    const convo = conversations.find(conversation => {
      return conversation.id === id
    })

    if(convo?.lastIncoming?.buyerUser) {
      const label = `Buyer: ${convo?.lastIncoming?.buyerUser?.buyer?.name}`
      if(collapsed) {
        label += `| User: ${
          convo?.lastIncoming?.buyerUser?.fullName
        }`
      }
      return label;
    }else {
      return 'Chat';
    }
  }

  const orderAndSetConversations = (newConversations) => {
    let unordered = [...newConversations];
    if(newConversations && newConversations.length > 0) {
      let ordered = unordered.sort(
        (a, b) => b.lastIncoming?.fromPaddleService - a.lastIncoming?.fromPaddleService ||
        b.isPendingResponse - a.isPendingResponse ||
        b.lastIncomingAt - a.lastIncomingAt
      );
      setConversations(ordered);
    }else {
      setConversations([]);
    }
    // setConversations(newConversations)
  }

  const value = {
    currentMessageInputRef: currentMessageInputRef,
    body: body,
    setBody: setBody,
    currentConversationId,
    currentConversationIds,
    conversations,
    conversationsList: conversations,
    setConversations,
    setCurrentConversationId: setCurrentConversationId,
    setCurrentConversationIds: setCurrentConversationIds,
    showModal,
    setShowModal,
    pendingResponseIds,
    setPendingResponseIds: setPendingResponseIds,
    openIds,
    collapsedIds,
    addToOpens: addToOpens,
    removeFromOpens: removeFromOpens,
    addToCollapsed: addToCollapsed,
    removeFromCollapsed: removeFromCollapsed,
    getConversationBuyerName: getConversationBuyerName,
    orderAndSetConversations: orderAndSetConversations
  };

  return (
    <MessageInputContext.Provider value={value}>
      {children}
    </MessageInputContext.Provider>
  );
};

export default MessageInputContext;
